export default {
  brand: "USFansLink.study",

  nav_home: "Home",
  nav_categories: "Categories",
  nav_articles: "Guides",
  nav_visit: "Visit Main Website",

  dropdown_label: "Browse categories",

  hero_eyebrow: "USFANS SPREADSHEET RESOURCE HUB",
  hero_title: "USFans Spreadsheet: Find, Compare & Explore Updated Resources",
  hero_subtitle:
    "Looking for a clearer way to explore USFans spreadsheet resources? USFansLink.study organizes guides, reviews, shipping information, warehouse resources, coupons, comparisons and safety information in one easy-to-navigate hub.",
  hero_cta_primary: "Explore USFans Spreadsheet",
  hero_cta_secondary: "Read the Beginner Guide",
  hero_trust: "Independent information • Practical guides • Safety-focused resources",

  search_title: "Search USFans Spreadsheet Resources",
  search_placeholder: "Search USFans spreadsheet, shipping, warehouse, reviews or coupons...",
  search_popular: "Popular searches",
  search_tags: ["USFans Spreadsheet", "USFans Review", "USFans Shipping Cost", "USFans Coupon", "USFans Warehouse", "Is USFans Legit?"],

  topics_title: "Popular Topics",
  topics_subtitle: "Start with the topic that matters most to you.",

  topic_1_title: "USFans Spreadsheet",
  topic_1_desc: "Explore spreadsheet resources, categories and guides.",
  topic_2_title: "USFans Review",
  topic_2_desc: "Understand the platform, features and key considerations.",
  topic_3_title: "USFans Shipping Cost",
  topic_3_desc: "Learn what can affect shipping prices and how to compare options.",
  topic_4_title: "USFans Coupon",
  topic_4_desc: "Learn how coupons and promotional offers work and how to verify them.",
  topic_5_title: "USFans Warehouse",
  topic_5_desc: "Understand warehouse storage, processing and related information.",
  topic_6_title: "Is USFans Legit?",
  topic_6_desc: "Learn how to evaluate trust signals, verify information and stay safer.",

  value_title: "Everything You Need to Understand USFans Spreadsheet Resources",
  value_subtitle:
    "USFans spreadsheet resources can contain useful information, but finding, comparing and verifying that information can be difficult. Our goal is to organize important topics into practical guides that are easy to understand and navigate.",
  value_1_title: "DISCOVER",
  value_1_desc: "Find relevant USFans spreadsheet resources.",
  value_2_title: "COMPARE",
  value_2_desc: "Compare information, options, costs and features.",
  value_3_title: "VERIFY",
  value_3_desc: "Learn how to check dates, links, claims and third-party information.",

  featured_title: "USFans Spreadsheet: Your Starting Point",
  featured_subtitle:
    "Start with the USFans Spreadsheet hub to explore guides, categories, comparisons, FAQs and updated resources.",
  featured_cta: "Open USFans Spreadsheet Hub",

  compare_title: "What Are You Looking For?",
  compare_col_topic: "Topic",
  compare_col_best: "Best For",
  compare_col_info: "Main Information",
  compare_rows: [
    ["USFans Spreadsheet", "Resource discovery", "Lists, categories and guides"],
    ["USFans Review", "Platform research", "Features and considerations"],
    ["Shipping Cost", "Shipping research", "Cost factors and options"],
    ["Coupon", "Offer research", "Coupons and promotions"],
    ["Warehouse", "Warehouse research", "Storage and processing"],
    ["Is USFans Legit?", "Trust research", "Verification and safety"],
  ],

  trust_title: "Research Before You Decide",
  trust_subtitle:
    "Online information can change quickly. A spreadsheet, coupon, shipping estimate or third-party link should not automatically be considered accurate simply because it appears online. Check dates, verify important information and use official sources for sensitive actions.",
  trust_cta: "Read Safety Guide",

  final_title: "Ready to Explore USFans Spreadsheet Resources?",
  final_subtitle:
    "Start with the USFans Spreadsheet hub, explore our latest guides and use the information to make better-informed decisions.",
  final_cta: "Explore USFans Spreadsheet",
  final_secondary: "Visit Main Website",

  btn_buy_now: "buy it now",
  btn_usfans: "usfans spreadsheet",

  categories_title: "Browse All Categories",
  categories_subtitle: "Jump straight to the section you need on the main website.",

  articles_title: "Latest USFans Spreadsheet Guides",
  articles_subtitle: "Original, helpful guides written to help you understand USFans resources.",
  article_1_title: "What Is USFans Spreadsheet? A Complete Beginner Guide",
  article_1_desc:
    "A clear, original introduction to USFans spreadsheet resources — what they are, how they help, and how to start using them safely.",
  article_read: "Read the guide",
  article_more: "More guides coming soon",
  article_related: "Related Guides",

  nav_shop_guide: "Shopping Guide",
  guide_eyebrow: "HOW TO SHOP",
  guide_title: "Your USFans Shopping Guide",
  guide_intro:
    "A simple, step-by-step guide to exploring USFans categories and completing your order on the official website.",
  guide_steps_title: "How to Shop in Four Steps",
  guide_steps: [
    { title: "Pick a category", desc: "Choose a category like shoes, hoodies or bags to see the products you are interested in." },
    { title: "Browse the selection", desc: "Open the category on the official website and compare the available items." },
    { title: "Check the details", desc: "Confirm price, availability, shipping and delivery before you decide." },
    { title: "Complete your order", desc: "Finish checkout securely on the official website and keep a record of your order." },
  ],
  guide_cta_title: "Ready to Start Shopping?",
  guide_cta_desc: "Head to the official website and browse the full USFans range at your own pace.",
  guide_back_home: "Back to Home",

  footer_about: "USFansLink.study is an independent informational resource. It is not affiliated with USFans or any third-party service mentioned on this website.",
  footer_disclaimer: "Information may change and should be independently verified.",
  footer_links: "Quick Links",
  footer_categories: "Categories",
  footer_rights: "All rights reserved.",

  cats: {
    shoes: "Shoes",
    hoodies: "Hoodies/Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants/Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear/Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },
};